import { SET_ACTIVE_NAV_LINK } from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    calendar: true,
    admin: false,
    orders: false,
    alerts: false,
    inventory: false,
    more: false,
    dashboard: false,
    deniedUsageOverrides: false,
    productGuide: false,
};

const navLinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_NAV_LINK:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'navLinkKey',
        storage: storage,
    },
    navLinkReducer
);
